import { render, staticRenderFns } from "./product-text.vue?vue&type=template&id=6a22bc07&"
import script from "./product-text.vue?vue&type=script&lang=js&"
export * from "./product-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports